import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Icon } from 'semantic-ui-react';
import { toggleModal } from '../Actions/ToggleModal';
import { modifyModalInfo } from '../Actions/ModifyModalInfo';

class GrantTeamAccessButton extends Component {
    constructor(props) {
        super(props);
    }

    onOpen = () => {
        const {
            resourceType,
            resourcePK,
            userPK,
            defaultAccessLevel = 'read',
            modalConfig = {},
            extraModalInfo = {},
        } = this.props;

        const effectiveUserPK = userPK;

        this.props.modifyModalInfo({
            modalOrigin: 'GrantTeamAccessButton',
            resourceType,
            resourcePK,
            userPK: effectiveUserPK,
            defaultAccessLevel,
            modalConfig,
            ...extraModalInfo,
        });

        this.props.toggleModal('grantTeamAccessModal');
    };

    render() {
        const { buttonText, icon = 'users', color = 'blue' } = this.props;
        return (
            <Button onClick={this.onOpen} color={color} data-testid="grant-team-access-btn">
                <Icon name={icon} />
                <span style={{ paddingLeft: 6 }}>{buttonText || 'Manage team access to this resource'}</span>
            </Button>
        );
    }
}

export default connect(null, { toggleModal, modifyModalInfo })(GrantTeamAccessButton);